import * as Yup from 'yup';
import { phoneExpression } from '../utility/phone-expression';


const DmvDetailsSchema = Yup.object().shape({
    dmvDetails: Yup.object().shape({
        firstName: Yup.string()
            .required('Required'),
        lastName: Yup.string()
            .required('Required'),
        phone: Yup.string()
            .matches(phoneExpression, 'Invalid phone number'),
    })
});

export default DmvDetailsSchema;